export default class KeyHelper {
    static createKeyOfObject(object = {}) {
        return JSON.stringify(object);
    }

    static createKeyOfString(string = '') {
        return string.split('').join('-'); 
    }

    static createKeyOfNumber(number = 0) {
        return number.toString().split('').join('-');
    }

    static isSameKey(key1 = '', key2 = '') {
        return key1 === key2;
    }
}